// src/components/NavBar.tsx
import { Link } from 'react-router-dom';
import './NavBar.css';

export default function NavBar() {
  return (
    <nav className="navbar">
      <Link to="/" className="navbar-brand no-link-style">
        <img src="/logo_only_256x256.png" alt="Pipelyze logo" className="navbar-logo" />
        <span className="company-name">Pipelyze</span>
      </Link>
      <ul className="navbar-links">
        {/* <li><Link to="/pricing">Pricing</Link></li> */}
        {/* <li><Link to="/login">Login</Link></li> */}
      </ul>
    </nav>
  );
}
